/*
 * Scroll lock — Pause Rituals
 * -----------------------------------------------------------------------------
 * Stops the page scrolling behind anything that opens over it — the cart drawer,
 * the menu drawer, the search panel, details-modal, pickup availability. All of
 * those already put `overflow-hidden` on <body>; this watches for that class.
 *
 * Why this and not the usual approaches:
 *
 *   html { overflow: hidden }   stops the scroll, but the browser clamps the scroll
 *                               position to 0 while it applies — so the page is at the
 *                               top when the drawer closes.
 *   body { position: fixed }    same problem, and it also breaks `position: sticky`
 *                               (the header would vanish while the drawer is open).
 *
 * Blocking the touch gesture leaves the scroll position completely untouched, so the
 * visitor closes the drawer exactly where they opened it. Desktop is already handled
 * by Dawn's `body.overflow-hidden { overflow: hidden }`.
 *
 * Scrolling INSIDE the panel keeps working: before blocking, we walk up from whatever
 * was touched and let the gesture through if it belongs to something that can still
 * scroll in that direction.
 */
(function () {
  'use strict';

  var startY = 0;

  function isLocked() {
    return document.body.classList.contains('overflow-hidden');
  }

  /*
   * Walk up from the touched node. If anything on the way is a scroll container with
   * somewhere left to go in this direction, the gesture is theirs — let it through.
   */
  function ownedByScroller(node, deltaY) {
    while (node && node !== document.body && node.nodeType === 1) {
      if (node.scrollHeight > node.clientHeight + 1) {
        var overflowY = getComputedStyle(node).overflowY;
        if (overflowY === 'auto' || overflowY === 'scroll') {
          var atTop = node.scrollTop <= 0;
          var atBottom = node.scrollTop + node.clientHeight >= node.scrollHeight - 1;
          // deltaY > 0 means the finger moved down, i.e. scrolling content up.
          if (!((deltaY > 0 && atTop) || (deltaY < 0 && atBottom))) return true;
        }
      }
      node = node.parentNode;
    }
    return false;
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      if (event.touches.length === 1) startY = event.touches[0].clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      if (!isLocked()) return;
      // Pinch-zoom and other multi-touch gestures are left alone.
      if (event.touches.length > 1) return;

      var deltaY = event.touches[0].clientY - startY;
      if (ownedByScroller(event.target, deltaY)) return;

      event.preventDefault();
    },
    { passive: false }
  );
})();
